/**
 * CUSTOMER-R4.6 — bounded receipt thumbnail. Original File is still uploaded.
 * PDF is never recompressed into a fake image.
 */
export async function createReceiptPreviewUrl(file: File): Promise<string | null> {
  if (/pdf/i.test(file.type) || /\.pdf$/i.test(file.name)) return null;
  const revokeLater = (url: string) => url;
  try {
    if (typeof createImageBitmap === "function") {
      const bitmap = await createImageBitmap(file);
      const max = 480;
      const scale = Math.min(1, max / Math.max(bitmap.width, bitmap.height));
      const w = Math.max(1, Math.round(bitmap.width * scale));
      const h = Math.max(1, Math.round(bitmap.height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        bitmap.close();
        return URL.createObjectURL(file);
      }
      ctx.drawImage(bitmap, 0, 0, w, h);
      bitmap.close();
      const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.72));
      if (blob) return URL.createObjectURL(blob);
    }
  } catch {
    /* fall through */
  }
  return revokeLater(URL.createObjectURL(file));
}
